import * as Tooltip from "@radix-ui/react-tooltip";

export const IconWithTooltip: React.FC<{
    icon: React.ReactNode;
    label: string;
}> = ({ icon, label }) => (
    <Tooltip.Provider delayDuration={200}>
        <Tooltip.Root>
            <Tooltip.Trigger asChild>
                <div className="__cursor-help flex h-[42px] w-[42px] items-center justify-center rounded-lg bg-[#cee5f0] p-2">
                    {icon}
                </div>
            </Tooltip.Trigger>
            <Tooltip.Portal>
                <Tooltip.Content
                    className="z-50 rounded-md bg-gray-900 px-3 py-2 text-sm text-white shadow-lg"
                    sideOffset={5}
                >
                    {label}
                    <Tooltip.Arrow className="fill-gray-900" />
                </Tooltip.Content>
            </Tooltip.Portal>
        </Tooltip.Root>
    </Tooltip.Provider>
);
